/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import redirect from 'js/lib/coursera.redirect';

import type { Theme } from '@coursera/cds-core';
import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coursera-plus-landing-page';

const styles: Record<string, Interpolation<Theme>> = {
  dialog: css`
    text-align: center;

    .cds-Dialog-dialog {
      min-height: 250px;
    }
  `,
  message: css`
    margin: 30px auto;
  `,
};

export type Props = {
  message: string;
  redirectUrlIfNotEligible?: string;
};

const PromoWarningModal = ({ message, redirectUrlIfNotEligible }: Props) => {
  const [acknowledged, setAcknowledged] = useState(false);
  if (acknowledged) {
    return null;
  }
  const closeModal = () => {
    setAcknowledged(true);
    if (redirectUrlIfNotEligible) {
      redirect.setLocation(redirectUrlIfNotEligible);
    }
  };
  const { Content } = Dialog;

  return (
    <Dialog aria-describedby="dialog-content" open={!acknowledged} css={styles.dialog} onClose={closeModal}>
      <Content data-test="modal-content" id="dialog-content">
        <Typography2 component="p" variant="bodyPrimary" css={styles.message}>
          {message}
        </Typography2>
        <Button type="button" size="medium" variant="secondary" data-testid="dialog-confirm" onClick={closeModal}>
          {_t('OK')}
        </Button>
      </Content>
    </Dialog>
  );
};

export default PromoWarningModal;
